import React, { Component } from 'react'
import './styles.css'
import cn from 'classnames'

function NetworkQuality({ qualityLevel, className }) {

  return (
    <div styleName='networkQualityContainer' className={className}>
      <div styleName={cn('level', { active: qualityLevel >= 1 })} />
      <div styleName={cn('level', { active: qualityLevel >= 2 })} />
      <div styleName={cn('level', { active: qualityLevel >= 3 })} />
      <div styleName={cn('level', { active: qualityLevel >= 4 })} />
      <div styleName={cn('level', { active: qualityLevel >= 5 })} />
    </div>
  )
}

export default NetworkQuality